import script from "./PlanBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanBadge.vue?vue&type=script&setup=true&lang=js"

import "./PlanBadge.vue?vue&type=style&index=0&id=07e72654&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e72654"]])

export default __exports__